import { render } from "./LiveFeed.vue?vue&type=template&id=53e9fd45"
import script from "./LiveFeed.vue?vue&type=script&lang=js"
export * from "./LiveFeed.vue?vue&type=script&lang=js"

import "./LiveFeed.vue?vue&type=style&index=0&id=53e9fd45&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__